import { render, staticRenderFns } from "./UserDriverList.vue?vue&type=template&id=73b50ca2"
import script from "./UserDriverList.vue?vue&type=script&lang=js"
export * from "./UserDriverList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports